function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  id: "info_inline_svg__Subtraction_87",
  "data-name": "Subtraction 87",
  d: "M-2980.161 4693.351a13.015 13.015 0 01-13-13 13.016 13.016 0 0113-13 13.016 13.016 0 0113 13 13.015 13.015 0 01-13 13zm5.384-14.8a1.8 1.8 0 00-1.795 1.8 1.8 1.8 0 001.795 1.795 1.8 1.8 0 001.8-1.795 1.8 1.8 0 00-1.8-1.796zm-5.384 0a1.8 1.8 0 00-1.8 1.8 1.8 1.8 0 001.8 1.795 1.8 1.8 0 001.794-1.795 1.8 1.8 0 00-1.794-1.796zm-5.384 0a1.8 1.8 0 00-1.8 1.8 1.8 1.8 0 001.8 1.795 1.8 1.8 0 001.794-1.795 1.8 1.8 0 00-1.794-1.796z",
  transform: "translate(2993.161 -4667.349)",
  fill: "#fff",
  opacity: 0.5
});

function SvgInfoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info_inline_svg__Component_16_4",
    "data-name": "Component 16 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26.002,
    viewBox: "0 0 26 26.002"
  }, props), _ref);
}

export default SvgInfoinline;